<div class="lazy-video-container">
  @if (loaded()) {
    <video
      [src]="src()"
      [poster]="poster()"
      [autoplay]="autoplay()"
      [loop]="loop()"
      [muted]="muted()"
      [attr.playsinline]="playsinline()"
      [height]="height()"
      [width]="width()"
      [class]="class()"
      [style]="{ display: loaded() ? 'block' : 'none' }"
    ></video>
  } @else {
    <img
      [src]="poster()"
      [width]="width()"
      [height]="height()"
      [class]="class()"
      loading="lazy"
    />
  }
</div>
